import { LazyModule, LazyImport } from 'owa-bundling';
import ProofingPlugin from './plugin/ProofingPlugin';
import createLazyPlugin, { LazyPlugin } from 'owa-editor-lazy-plugin/lib/utils/createLazyPlugin';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "ProofingPlugin" */ './lazyIndex')
);

export type LazyProofingPlugin = LazyPlugin<ProofingPlugin>;

export let LazyProofingPluginClass = createLazyPlugin(
    lazyModule,
    m => m.ProofingPlugin,
    'Proofing',
    null
);

export let lazyDisableProofing = new LazyImport(lazyModule, m => m.disableProofing);
export let lazyToggleProofingSetting = new LazyImport(lazyModule, m => m.toggleProofingSetting);
export let lazyShowProofingLanguagePicker = new LazyImport(
    lazyModule,
    m => m.showProofingLanguagePicker
);
export let lazyShowEditorSettings = new LazyImport(lazyModule, m => m.showEditorSettings);
